import BankAccountDetailsContextProvider from './Providers/BankAccountDetailsContextProvider'
import { BankAccountDetails } from './BankAccountDetails'
import BankAccountPopupProvider from '../Providers/BankAccountPopupProvider'

export const BankAccountDetailsContainer = () => {
  return (
    <BankAccountPopupProvider>
      <BankAccountDetailsContextProvider>
        <BankAccountDetails />
      </BankAccountDetailsContextProvider>
    </BankAccountPopupProvider>
  )
}
